// @flow

import { getPagination } from "@selectors";
import type { State } from "@store/reducers";
import type { OptionType } from "@components";
import type { StaffGroup } from "@modules/service/reducer/staff-groups/types";
export const disableStaffGroupsModalVisible = (state: State) =>
  state.service.staffGroups.modals.disable.visible;

export const staffGroupName = (state: State): ?string => state.service.staffGroups.modals.name;

export const getNumberOfEmployees = (state: State): ?number =>
  state.service.staffGroups.modals.numberEmployees;

export const enableStaffGroupsModalVisible = (state: State) =>
  ((state.service.staffGroups.modals || {}).enable || {}).visible;

export const reassignStaffGroupsModalVisible = (state: State) =>
  state.service.staffGroups.modals.reassign.visible;

export const getStaffGroupSchema = (state: State) => state.service.staffGroups.schema.staffGroup;

export const getStaffGroupsSchema = (state: State) => state.service.staffGroups.schema.staffGroups;

export const getStaffGroups = (state: State): Array<StaffGroup> =>
  state.service.staffGroups.list.content;

export const getStaffGroupsOptions = (state: State) => {
  const content = state.service.staffGroups.list.content || [];
  const filteredContent = content.filter(
    item => item.isEnabled === true && item.name !== staffGroupName(state),
  );

  return filteredContent.map(item => ({
    value: item.id,
    label: item.name,
  }));
};

export const getStaffGroupsPagination = (state: State) =>
  getPagination(state.service.staffGroups.list);

export const getIsAddStaffGroupModalVisible = (state: State) =>
  state.service.staffGroups.modals.addStaffGroup.visible;

export const getStaffGroupFormData = (state: State) =>
  state.service.staffGroups.modals.editStaffGroup.formData;

export const getIsEditStaffGroupModalVisible = (state: State) =>
  state.service.staffGroups.modals.editStaffGroup.visible;

export const getStaffGroupId = (state: State): ?number =>
  state.service.staffGroups.modals.staffGroupId;

export const staffGroupsConfiguration = (state: State) => state.service.staffGroups.configuration;

export const getStaffGroupsSort = (state: State) =>
  (((state.service.staffGroups.list || {}).pagination || {}).sort || {}).orders;

export const getStaffGroupTotalElements = (state: State): number => {
  return (((state.service || {}).staffGroups || {}).list || {}).totalElements;
};

export const getTotalStaffGroupList = (state: State): Array<OptionType> => {
  const staffGroups = ((state.service || {}).staffGroups || {}).totalList;

  if (staffGroups && staffGroups.length) {
    const list = staffGroups.filter(el => el.isEnabled && el.name !== staffGroupName(state));
    return list.map(el => ({
      value: el.id,
      label: el.name,
    }));
  }

  return [];
};

export const getStaffGroupLoading = (state: State) => {
  return state.service.staffGroups.isLoading;
};
